export function authUserId(){
    let userData =  localStorage.getItem("userData")
    userData = JSON.parse(userData)
    const userId = userData.userId
    return userId;
}